export default {
  getMessage: (state) => state.message,
};
